var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnreadChats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20777_56178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20777_56178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66406 18.3332V3.33317C1.66406 2.87484 1.82726 2.48248 2.15365 2.15609C2.48003 1.8297 2.8724 1.6665 3.33073 1.6665H16.6641C17.1224 1.6665 17.5148 1.8297 17.8411 2.15609C18.1675 2.48248 18.3307 2.87484 18.3307 3.33317V13.3332C18.3307 13.7915 18.1675 14.1839 17.8411 14.5103C17.5148 14.8366 17.1224 14.9998 16.6641 14.9998H4.9974L1.66406 18.3332ZM4.28906 13.3332H16.6641V3.33317H3.33073V14.2707L4.28906 13.3332Z",
    fill: "#667085"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadChats);
export default __webpack_public_path__ + "static/media/unread-chats.629e4a965b86bd2fc0fbc7a8f221c34d.svg";
export { ForwardRef as ReactComponent };